import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
export const StyleViewBtn = styled(Link)`
  background: ${(props: any) => props.theme.colors.primary100};
  border-radius: 4px;
  padding: 8px 20px;
  color: ${(props: any) => props.theme.colors.secondary};
  font-size: 14px;
`
